import { render, staticRenderFns } from "./FooterPerfil.vue?vue&type=template&id=65736500"
import script from "./FooterPerfil.vue?vue&type=script&lang=js"
export * from "./FooterPerfil.vue?vue&type=script&lang=js"
import style0 from "./FooterPerfil.vue?vue&type=style&index=0&id=65736500&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports